// components/SEO.js
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, keywords, canonical }) => (
    <Helmet>
            <title>{title}</title>
            <meta name="description" content={description}/>
            <meta name="keywords" content={keywords}/>
            {/* Open Graph tags */}
            <meta property="og:title" content={title}/>
            <meta property="og:description" content={description}/>
            <meta property="og:type" content="website"/>
            <meta property="og:image" content="/youtube.svg"/>
            {/* Add the path to your image */}
            {/* Twitter Card tags */}
            <meta name="twitter:card" content="/youtube.svg"/>
            <meta name="twitter:title" content={title}/>
            <meta name="twitter:description" content={description}/>
            <meta name="twitter:image" content="/youtube.svg"/>
            {/* Add the path to your image */}
            <link rel="canonical" href={canonical}/>
    </Helmet>
);

export default SEO;